import { HeaderLink as e, HeaderNavLink as t } from "../base/HeaderLink.js";
import { getLevelState as n, handleNextLevelClick as r, isCyoItem as i } from "../navState.js";
import { MenuSlidingPanel as a } from "./MenuSlidingPanel.js";
import { MobileCyoPortal as o } from "./MobileCyoPortal.js";
import { Button as s, Chevron as c } from "@sprd/sprd-component-kit/v2";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/components/Header/mobile/MobileNavLevels.tsx
function d({ item: t, activeLevel: i, levelStates: o, setLevelStates: d, navRef: h, closeLabel: g, linkComponent: _ }) {
	let v = n(o, t.key);
	if (!v) return null;
	let y = !!(i && i.levelIndex > 1), b = `calc(100dvh - var(--mobile-nav-header-height) - ${v.isCYO ? "var(--header-banner-height)" : "0"} - var(--cyo-button-portal-height))`, x = /* @__PURE__ */ u("div", {
		className: "flex flex-col items-start justify-start gap-0 text-left text-base",
		children: [/* @__PURE__ */ l("span", {
			className: "font-made font-normal",
			children: t.label
		}), /* @__PURE__ */ l("span", {
			className: "font-normal text-neutral-700",
			children: t.subLabel
		})]
	});
	return /* @__PURE__ */ u("li", { children: [!v.hasContent && t.link ? /* @__PURE__ */ l(s, {
		variant: "plain",
		className: "flex w-full justify-between! gap-2 px-0!",
		asChild: !0,
		children: /* @__PURE__ */ l(e, {
			link: t.link,
			linkComponent: _,
			children: x
		})
	}) : /* @__PURE__ */ u(s, {
		onClick: () => r(d, v),
		variant: "plain",
		className: "flex w-full justify-between! gap-2 px-0!",
		inert: !!i,
		children: [x, /* @__PURE__ */ l(c, { className: "size-6 -rotate-90" })]
	}), /* @__PURE__ */ l(a, {
		isShown: v.isShown,
		shiftLeft: y,
		className: "inset-0",
		style: { height: b },
		children: /* @__PURE__ */ u("div", {
			className: "overflow-y-auto",
			children: [/* @__PURE__ */ l("ul", {
				className: "flex flex-col gap-3 p-4",
				children: t.children ? t.children.map((e) => /* @__PURE__ */ l(f, {
					item: e,
					levelStates: o,
					setLevelStates: d,
					level1State: v,
					navRef: h,
					levelHeight: b,
					isLevel2Open: y,
					closeLabel: g,
					linkComponent: _
				}, e.key)) : /* @__PURE__ */ l(p, {
					columns: t.columns ?? [],
					teaser: t.teaser,
					isShown: v.isShown,
					levelHeight: b,
					shiftLeft: !0,
					linkComponent: _
				})
			}), t.children ? /* @__PURE__ */ l("div", {
				className: "border-t border-neutral-200 sm:py-9",
				children: /* @__PURE__ */ l(m, { teaser: t.teaser })
			}) : null]
		})
	})] });
}
function f({ item: e, levelStates: a, setLevelStates: d, level1State: f, navRef: m, levelHeight: h, isLevel2Open: g, closeLabel: _, linkComponent: v }) {
	let y = n(a, e.key);
	if (!y) return null;
	let b = "flex w-full items-center !justify-between px-0!", x = (e.columns?.length ?? 0) > 0;
	return i(e) ? /* @__PURE__ */ l(o, {
		navRef: m,
		isShown: f.isShown,
		item: e,
		closeLabel: _,
		linkComponent: v
	}) : !x && e.link ? /* @__PURE__ */ l("li", { children: /* @__PURE__ */ l(s, {
		variant: "plain",
		className: b,
		asChild: !0,
		children: /* @__PURE__ */ l(t, {
			link: e.link,
			linkComponent: v,
			className: "border-transparent!",
			children: /* @__PURE__ */ l("span", {
				className: "text-base font-normal",
				children: e.label
			})
		})
	}) }) : /* @__PURE__ */ u("li", { children: [/* @__PURE__ */ u(s, {
		onClick: () => r(d, y),
		variant: "plain",
		className: b,
		inert: g,
		children: [/* @__PURE__ */ l("span", {
			className: "text-base font-normal",
			children: e.label
		}), /* @__PURE__ */ l(c, { className: "size-6 -rotate-90" })]
	}), /* @__PURE__ */ l(p, {
		columns: e.columns ?? [],
		teaser: e.teaser,
		isShown: y.isShown,
		levelHeight: h,
		linkComponent: v
	})] });
}
function p({ columns: e, teaser: n, isShown: r, levelHeight: i, shiftLeft: o = !1, linkComponent: c }) {
	return /* @__PURE__ */ u(a, {
		isShown: r,
		shiftLeft: o,
		className: "inset-0 overflow-y-auto py-4",
		style: { height: i },
		children: [/* @__PURE__ */ l("ul", {
			className: "flex flex-col gap-3 px-4 pb-4",
			children: e.flat().map((e) => e.link ? /* @__PURE__ */ l("li", { children: /* @__PURE__ */ l(s, {
				variant: "plain",
				className: "flex w-full justify-between! px-0!",
				asChild: !0,
				children: /* @__PURE__ */ l(t, {
					link: e.link,
					linkComponent: c,
					className: "border-transparent!",
					children: /* @__PURE__ */ l("span", {
						className: "text-base font-normal",
						children: e.label
					})
				})
			}) }, e.key) : null)
		}), /* @__PURE__ */ l("div", {
			className: "border-t border-neutral-200 sm:py-9",
			children: /* @__PURE__ */ l(m, { teaser: n })
		})]
	});
}
function m({ teaser: e }) {
	return e ? /* @__PURE__ */ u("div", {
		className: "py-4",
		children: [e.headline ? /* @__PURE__ */ l("span", {
			className: "mb-3 block px-4 font-made",
			children: e.headline
		}) : null, e.content]
	}) : null;
}
//#endregion
export { d as MobileNavLevel1 };
